import { render, staticRenderFns } from "./WebphoneMinimized.vue?vue&type=template&id=0a10d43c&scoped=true&"
import script from "./WebphoneMinimized.vue?vue&type=script&lang=js&"
export * from "./WebphoneMinimized.vue?vue&type=script&lang=js&"
import style0 from "./WebphoneMinimized.vue?vue&type=style&index=0&id=0a10d43c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a10d43c",
  null
  
)

export default component.exports